import siteCard from './components/siteCard'
import sitesHeading from './components/sitesHeading'
import editSiteCard from './components/editSiteCard'
import improvementAlert from './components/improvementAlert'
import editor from './editor'
import favicon from './favicon'
import list from './list'
import welcome from './welcome'

export default {
  components: {
    siteCard,
    sitesHeading,
    editSiteCard,
    improvementAlert
  },
  list,
  welcome,
  editor,
  favicon
}
